import type { RouteRecordRaw } from 'vue-router';
import { SETUP_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupRoutes: RouteRecordRaw = {
  path: '/setup',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: SETUP_ROUTE_NAME.SETUP, path: '', component: () => import('./Setup.vue') },
  ],
};

export const setupRedirects: RouteRecordRaw[] = [
  { path: '/settings', redirect: { name: SETUP_ROUTE_NAME.SETUP } },
  { path: '/settings/store', redirect: { name: SETUP_ROUTE_NAME.STORE_SETTINGS } },
  { path: '/settings/payment-method-management', redirect: { name: SETUP_ROUTE_NAME.PAYMENT_METHOD_MANAGEMENT } },
  { path: '/settings/admin', redirect: { name: SETUP_ROUTE_NAME.ADMIN } },
  { path: '/settings/checkout-setup', redirect: { name: SETUP_ROUTE_NAME.CHECKOUT_SETUP } },
  { path: '/settings/turn-tracker-setup', redirect: { name: SETUP_ROUTE_NAME.TURN_TRACKER_SETUP } },
  { path: '/settings/store-landing', redirect: { name: SETUP_ROUTE_NAME.STORE_LANDING } },
];
